import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';

import { getReviews, getReviewsStats } from '../../selectors/developerV2';
import { TeaserReviewSlide } from '../../components/ReviewsTeaser/parts/Teaser';
import { ReviewsTeaserLayout } from '../../components/ReviewsTeaser/ReviewsTeaserLayout';
import { ReviewsTitle } from '../../components/ReviewsTeaser/parts/Teaser/ReviewsTitle';
import { VerticalSlider } from '../../components/VerticalSlider';
import { ReviewItem } from '../../components/ReviewsTeaser/parts/ReviewItem';
import { ReviewAuthor } from '../../components/ReviewCommon/ReviewAuthor';
import { ReviewComment } from '../../components/ReviewsTeaser/parts/ReviewComment';
import { ReviewAnswers } from '../../components/ReviewCommon/ReviewAnswers';
import { ReviewsReactionsContainer } from '../ReviewsReactionsContainer';
import { ReviewsFooter } from '../../components/ReviewsTeaser/parts/Teaser/ReviewsFooter';
import { trackAllReviewsClick, trackReviewsClick } from '../Reviews/tracking';
import { setReviewDetailsOpenAction } from '../../actions/reviewsDetails/actions';
import { pluralize } from '@cian/newbuilding-utils';

export const ReviewsTeaserContainer: React.FC = () => {
  const dispatch = useDispatch();
  const reviews = useSelector(getReviews);
  const reviewStat = useSelector(getReviewsStats);

  const onReadAllClick = React.useCallback(() => {
    trackAllReviewsClick();
    dispatch(setReviewDetailsOpenAction({ reviewId: null }));
  }, []);

  const onReviewItemClick = React.useCallback((reviewId: string) => {
    trackReviewsClick();
    dispatch(setReviewDetailsOpenAction({ reviewId }));
  }, []);

  const buttonText = React.useMemo(() => {
    const count = reviews.length;

    return `Показать ${pluralize(count, ['популярный отзыв', 'популярных отзыва', 'популярных отзывов'])}`;
  }, [reviews]);

  return (
    <ReviewsTeaserLayout>
      <ReviewsTitle rating={reviewStat.totalRate} title="Средняя оценка по отзывам на ЖК" />
      <VerticalSlider arrowOffset={0}>
        {reviews.map(
          ({ id, url, user, date, isLegacy, comment, rating, answersCount, newbuildingName, newbuildingUrl, like }) => (
            <TeaserReviewSlide key={id}>
              <ReviewItem
                author={
                  <ReviewAuthor
                    newbuildingName={newbuildingName}
                    newbuildingUrl={newbuildingUrl}
                    avatarUrl={user.avatarUrl}
                    name={user.name}
                    date={date}
                    rating={rating}
                  />
                }
                comment={
                  <ReviewComment
                    isLegacy={isLegacy}
                    comment={comment}
                    onReadFullReviewClick={() => onReviewItemClick(id)}
                  />
                }
                answers={<ReviewAnswers url={url} answersCount={answersCount} />}
                reaction={<ReviewsReactionsContainer reviewId={id} reactions={like} />}
              />
            </TeaserReviewSlide>
          ),
        )}
      </VerticalSlider>
      <ReviewsFooter>
        <Button theme="fill_secondary" fullWidth={true} onClick={onReadAllClick}>
          {buttonText}
        </Button>
      </ReviewsFooter>
    </ReviewsTeaserLayout>
  );
};
